import Container from '@/components/Container/Container';
import { SortByType, getSortedContent } from '@/shared/helpers/sort';
import { useBreakpoints } from '@/shared/providers/Device';
import { useThemeSection } from '@/shared/providers/SectionContext';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import ProjectListingDesktop from './Desktop/ProjectListingDesktop';
import ProjectListingMobile from './Mobile/ProjectListingMobile';
import styles from './ProjectListing.module.scss';

type ProjectListingCoreProps = {
    content: any;
    loadMoreButton?: string;
    sortBy: SortByType;
    startingItems?: number;
};

const ProjectListingCore: React.FC<ProjectListingCoreProps> = props => {
    const { content: originalContent, sortBy, loadMoreButton, startingItems = 1000 } = props;
    const [content, setContent] = useState(originalContent);
    const theme = useThemeSection();
    const isDark = theme === 'Dark';
    const { isLarge, isExtraLarge, isXXSmall } = useBreakpoints();
    const isMobile = !isExtraLarge && !isLarge;
    useEffect(() => {
        if (originalContent && originalContent.length > 0) {
            let sortedContent = [...originalContent];
            if (sortBy) {
                sortedContent = getSortedContent(sortedContent, sortBy);
            }
            setContent(sortedContent);
        }
    }, [sortBy, originalContent]);

    return (
        <Container code="fullpage" className={{ wrap: clsx(styles.root, { [styles.dark]: isDark }) }}>
            {isMobile ? (
                <ProjectListingMobile content={content} isDark={isDark} xSmall={isXXSmall} />
            ) : (
                <ProjectListingDesktop
                    content={content}
                    loadMoreButton={loadMoreButton || 'Load more'}
                    isDark={isDark}
                    startingItems={startingItems}
                />
            )}
        </Container>
    );
};

export default ProjectListingCore;
